'use client';

import { useState, useMemo, useRef, useEffect } from 'react';
import Link from '../components/SafeLink';
import { CustomCheckbox } from '../components/forms/CustomCheckbox';

interface Post {
  id: string;
  title: string;
  cat: string;
  tags: string[];
  author: string;
  date: string;
  read: number;
  views: number;
  cover: string;
  badges: string[];
  excerpt: string;
  html: string;
}

const POSTS: Post[] = [
  {
    id: 'p2', title: 'Кейс: 180 закрытий/кв. в маркетплейсе', cat: 'Кейсы',
    tags: ['E-commerce', 'RPO', 'BI'], author: 'Д. Орлов', date: '2025-08-11', read: 6, views: 980,
    cover: 'https://avatars.mds.yandex.net/i?id=2adfd7db122f7161010aaf44cc47f04b_l-4914299-images-thumbs&n=13', badges: ['HOT'],
    excerpt: 'Как построили поток кандидатов и ускорили интервью — реальные цифры.',
    html: `<p>Мы настроили 7 каналов, автоматизировали письма и сделали BI-дашборд.</p><p>Результат — <b>180 закрытий за квартал</b>, CPH −19%, явка 96%.</p>`
  },
  {
    id: 'p3', title: 'Аналитика: CPH и скорость найма в 2025', cat: 'Аналитика',
    tags: ['KPI', 'Аналитика'], author: 'М. Беляев', date: '2025-07-25', read: 10, views: 1500,
    cover: 'https://i.ytimg.com/vi/RIKDdZpBZTw/maxresdefault.jpg', badges: ['FEATURED'],
    excerpt: 'Связь стоимости найма и времени закрытия. Что влияет больше всего.',
    html: `<p>Разобрали влияние источников, конверсий этапов и SLA на CPH и Time-to-Hire.</p>`
  },
  {
    id: 'p4', title: 'Новости: Запуск MSP пула', cat: 'Новости',
    tags: ['MSP', 'Партнёры'], author: 'Редакция', date: '2025-08-09', read: 4, views: 600,
    cover: 'https://avatars.mds.yandex.net/i?id=1216c2e86922e52bc492e15a1e284df5_l-4012804-images-thumbs&ref=rim&n=13&w=2560&h=1439', badges: ['NEW'],
    excerpt: 'Старт мультивендорной модели: единые KPI и контроль качества.',
    html: `<p>Подключили партнёров к единому SLA, отчётность — в едином BI.</p>`
  },
  {
    id: 'p5', title: 'Гайд: воронка кандидата и явка', cat: 'Гайды',
    tags: ['ATS', 'CRM', 'Явка'], author: 'А. Иванова', date: '2025-06-20', read: 9, views: 730,
    cover: 'https://st49.stpulscen.ru/images/product/263/709/445_big.jpg', badges: [],
    excerpt: 'Как повысить явку за счет коммуникаций и слот-менеджмента.',
    html: `<p>Шаблоны писем, напоминания и согласование слотов уменьшают no-show.</p>`
  },
  {
    id: 'p6', title: 'Кейс: L1/L2 поддержка — аутстаффинг', cat: 'Кейсы',
    tags: ['IT/Саппорт', 'Обучение'], author: 'Д. Орлов', date: '2025-05-30', read: 7, views: 520,
    cover: 'https://blog.rubrain.com/wp-content/uploads/2020/07/1-1.jpg', badges: [],
    excerpt: 'Укомплектовали линию поддержки, внедрили обучение и QA.',
    html: `<p>Набрали линию L1/L2, подготовили скрипты и провели QA-оценку.</p>`
  },
  {
    id: 'p8', title: 'Гайд: автоматизация рассылок кандидатам', cat: 'Гайды',
    tags: ['Автоматизация', 'Email'], author: 'М. Беляев', date: '2025-04-18', read: 8, views: 680,
    cover: 'https://avatars.mds.yandex.net/i?id=12913bd0e1424f7ec0779ed11ca7a06b_l-10961631-images-thumbs&n=13', badges: [],
    excerpt: 'Триггеры, шаблоны, A/B — и чтобы не выглядело как спам.',
    html: `<p>Используем webhooks и шаблоны сообщений по статусам ATS.</p>`
  },
  {
    id: 'p9', title: 'Аналитика: рынок труда e-commerce', cat: 'Аналитика',
    tags: ['E-commerce', 'Рынок'], author: 'Редакция', date: '2025-03-10', read: 11, views: 900,
    cover: 'https://avatars.mds.yandex.net/i?id=4e54956c53139c07d4d8fedf678d6030_l-5233472-images-thumbs&ref=rim&n=13&w=1440&h=900', badges: [],
    excerpt: 'Кого не хватает и как конкурировать за кандидатов.',
    html: `<p>Сравнили спрос и предложение по ролям, городам, зарплатам.</p>`
  },
  {
    id: 'p10', title: 'Кейс: сезонный аутсорс рекрутинга', cat: 'Кейсы',
    tags: ['Аутсорс', 'Сезон'], author: 'А. Иванова', date: '2025-11-05', read: 5, views: 400,
    cover: 'https://avatars.mds.yandex.net/get-ydo/4498943/2a00000189968b5c187fee41f5a68ab10458/diploma', badges: [],
    excerpt: 'Как масштабировали команду на три месяца без потери качества.',
    html: `<p>Экспресс-онбординг и четкие SLA помогли пройти пик сезона.</p>`
  },
];

const ALL_TAGS = [...new Set(POSTS.flatMap(p => p.tags))].sort((a, b) => a.localeCompare(b, 'ru'));
const ALL_CATS = [...new Set(POSTS.map(p => p.cat))];

function formatDate(dateString: string): string {
  return new Date(dateString).toLocaleDateString('ru-RU', { year: 'numeric', month: 'long', day: 'numeric' });
}

interface ArticleCardProps {
  post: Post;
  onOpenModal: (post: Post) => void;
}
const ArticleCard = ({ post, onOpenModal }: ArticleCardProps) => {
  const { title, cat, date, read, author, cover, badges, excerpt, tags } = post;

  const handleShare = async () => {
    if (navigator.share) {
      try {
        await navigator.share({
          title: post.title,
          text: post.excerpt,
          url: location.origin + location.pathname + '#post-' + post.id,
        });
      } catch (error) {
        console.error('Ошибка при попытке поделиться:', error);
      }
    } else {
      alert('Ваш браузер не поддерживает функцию «Поделиться».');
    }
  };

  return (
    <article className="card rounded-2xl overflow-hidden flex flex-col">
      <img
        src={cover}
        alt=""
        className="w-full h-40 object-cover md:h-44"
        onError={(e) => { e.currentTarget.src = 'https://placehold.co/800x480?text=Article'; }}
      />
      <div className="p-4 sm:p-5 flex-1 flex flex-col text-white">
        <div className="flex items-start justify-between gap-3">
          <h3 className="text-lg sm:text-xl font-semibold">{title}</h3>
          <div className="flex gap-1 flex-shrink-0 mt-0.5">
            {badges?.includes('NEW') && <span className="badge badge-new">New</span>}
            {badges?.includes('HOT') && <span className="badge badge-hot">Hot</span>}
            {badges?.includes('FEATURED') && <span className="badge badge-feat">Featured</span>}
          </div>
        </div>
        <div className="mt-1 text-xs flex flex-wrap gap-2">
          <span className="tag">{cat}</span>
          <span className="tag">{formatDate(date)}</span>
          <span className="tag">{read} мин</span>
          <span className="tag">{author}</span>
        </div>

        <p className="text-sm text-gray-200 mt-3">{excerpt || ''}</p>
        <div className="mt-3 flex flex-wrap items-center gap-2 text-xs">
          {tags?.slice(0, 3).map(t => <span key={t} className="tag">{t}</span>)}
        </div>

        <div className="mt-4 pt-3 border-t border-white/10 flex flex-col gap-2 md:flex-row md:gap-3 mt-auto">
          <button className="btn btn-ghost text-sm w-full md:w-auto" onClick={handleShare}>Поделиться</button>
          <button className="btn btn-ghost text-sm w-full md:w-auto" onClick={() => { navigator.clipboard.writeText(location.origin + location.pathname + '#post-' + post.id); alert('Ссылка скопирована.'); }}>Скопировать ссылку</button>
          <button className="btn btn-accent text-sm w-full md:w-auto" onClick={() => onOpenModal(post)}>Читать</button>
        </div>
      </div>
    </article>
  );
};

interface ArticleModalProps {
  post: Post;
  onClose: () => void;
}
const ArticleModal = ({ post, onClose }: ArticleModalProps) => {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-90 p-4 sm:p-0" onClick={onClose}>
      <div
        className="rounded-2xl p-4 sm:p-6 max-w-3xl w-full sm:w-[92%] relative max-h-[95vh] sm:max-h-[90vh] overflow-y-auto bg-blue-900 text-white"
        onClick={e => e.stopPropagation()}
      >
        <button className="absolute right-3 top-3 px-2 py-1 rounded-full btn-ghost text-xl" onClick={onClose}>✕</button>
        <article>
          <img
            src={post.cover}
            alt=""
            className="rounded-xl w-full h-40 object-cover sm:h-56"
          />
          <h2 className="text-xl sm:text-2xl font-bold mt-4">{post.title}</h2>
          <div className="mt-2 text-xs flex flex-wrap gap-2">
            <span className="tag">{post.cat}</span>
            <span className="tag">{formatDate(post.date)}</span>
            <span className="tag">{post.read} мин чтения</span>
            <span className="tag">{post.author}</span>
          </div>
          <div
            className="prose prose-invert max-w-none mt-4 text-sm sm:text-base"
            dangerouslySetInnerHTML={{ __html: post.html || '<p>' + (post.excerpt || '') + '</p>' }}
          />
          <div className="mt-4 flex gap-2">
            <button className="btn btn-ghost text-sm" onClick={() => { navigator.clipboard.writeText(location.origin + location.pathname + '#post-' + post.id); alert('Ссылка скопирована.'); }}>Скопировать ссылку</button>
          </div>
        </article>
      </div>
    </div>
  );
};

export default function BlogPage() {
  const [query, setQuery] = useState('');
  const [category, setCategory] = useState('');
  const [tag, setTag] = useState('');
  const [yearRange, setYearRange] = useState({ start: 2025, end: 2026 });
  const [sort, setSort] = useState('date');
  const [page, setPage] = useState(1);
  const [selectedPost, setSelectedPost] = useState<Post | null>(null);

  const listSectionRef = useRef<HTMLDivElement>(null);

  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [isConsentChecked, setIsConsentChecked] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [status, setStatus] = useState<'idle' | 'success' | 'error'>('idle');
  const [message, setMessage] = useState('');

  const perPage = 6;

  const filteredPosts = useMemo(() => {
    let items = POSTS.filter(p => {
      const q = query.toLowerCase();
      const hay = (p.title + ' ' + (p.excerpt || '') + ' ' + (p.tags || []).join(' ')).toLowerCase();
      const y = new Date(p.date).getFullYear();
      return (!q || hay.includes(q)) &&
        (!category || p.cat === category) &&
        (!tag || (p.tags && p.tags.includes(tag))) &&
        (y >= yearRange.start && y <= yearRange.end);
    });

    switch (sort) {
      case 'date':
        items.sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime());
        break;
      case 'popular':
        items.sort((a, b) => (b.views || 0) - (a.views || 0));
        break;
      case 'title':
        items.sort((a, b) => a.title.localeCompare(b.title, 'ru'));
        break;
      case 'read':
        items.sort((a, b) => (a.read || 0) - (b.read || 0));
        break;
      default:
        break;
    }
    return items;
  }, [query, category, tag, yearRange, sort]);

  const totalPages = Math.max(1, Math.ceil(filteredPosts.length / perPage));
  const paginatedPosts = filteredPosts.slice((page - 1) * perPage, page * perPage);

  useEffect(() => {
    if (page > totalPages) {
      setPage(totalPages);
    }
  }, [page, totalPages]);

  const handleConsentChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setIsConsentChecked(e.target.checked);
    if (e.target.checked && status === 'error' && message.includes('согласитесь с политикой')) {
      setStatus('idle');
      setMessage('');
    }
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (isSubmitting || status === 'success') return;
    if (!name.trim() || !email.trim()) {
      setStatus('error');
      setMessage('❌ Пожалуйста, заполните все поля.');
      return;
    }
    if (!isConsentChecked) {
      setStatus('error');
      setMessage('❌ Пожалуйста, согласитесь с политикой конфиденциальности.');
      return;
    }

    setIsSubmitting(true);
    setStatus('idle');
    setMessage('');

    try {
      const res = await fetch(`${process.env.NEXT_PUBLIC_STRAPI_API_URL}/api/subscriptions`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          data: {
            name,
            email,
            formName: "Блог", 
          },
        }),
      });

      console.log('Response status:', res.status);
      console.log('Request body:', JSON.stringify({ data: { name, email } }));

      if (res.ok) {
        setMessage('✅ Спасибо! Вы подписаны.');
        setName('');
        setEmail('');
        setIsConsentChecked(false);
        setStatus('success');
      } else {
        const responseText = await res.text();
        console.error('Response text:', responseText);
        let errorMessage = 'Неизвестная ошибка сервера.';
        try {
          const errorData = JSON.parse(responseText);
          errorMessage = errorData.error?.message || res.statusText || `Ошибка ${res.status}`;
        } catch (parseError) {
          console.error('Parse error:', parseError);
          errorMessage = `Ошибка сервера: ${res.status} - ${responseText.substring(0, 100)}...`;
        }
        setStatus('error');
        setMessage(`❌ Ошибка отправки: ${errorMessage}`);
      }
    } catch (err) {
      console.error('Network or other error:', err);
      setStatus('error');
      setMessage('❌ Произошла ошибка сети. Попробуйте позже.');
    } finally {
      setIsSubmitting(false);
    }
  };

  const StatusMessage: React.FC = () => {
    if (status === 'idle') return null;

    const className = status === 'success'
      ? 'text-green-400 bg-green-900/50'
      : 'text-red-400 bg-red-900/50';

    return (
      <p className={`mt-3 px-4 py-2 rounded-xl text-sm ${className} md:col-span-3`} role="alert">
        {message}
      </p>
    );
  };

  return (
    <>
      <div className="bg-gradient-to-br from-blue-900 to-blue-800 text-gray-100">
        <header className="px-6 pt-32 pb-16 md:pt-40 md:pb-20"
          style={{ background: 'linear-gradient(rgba(0,0,0,.45), rgba(0,0,0,.25)), radial-gradient(1200px 600px at 70% -10%, rgba(255,255,255,.08), transparent)' }}>
          <div className="max-w-7xl mx-auto">
            <nav className="mb-6 flex flex-wrap gap-3 text-sm">
              <Link href="#list" className="chip px-3 py-1 rounded-full hover:bg-white/25">Все статьи</Link>
              <Link href="#filters" className="chip px-3 py-1 rounded-full hover:bg-white/25">Фильтры</Link>
              <Link href="#subscribe" className="chip px-3 py-1 rounded-full hover:bg-white/25">Подписка</Link>
              <Link href="#faq" className="chip px-3 py-1 rounded-full hover:bg-white/25">FAQ</Link>
            </nav>
            <h1 className="text-4xl md:text-6xl font-extrabold mb-4">Блог INTERIM</h1>
            <p className="max-w-3xl text-lg md:text-xl text-gray-200">
              Новости, кейсы, гайды и аналитика о найме: RPO, аутсорс/аутстафф, воронки, KPI и автоматизация.
            </p>
            <div className="mt-8 flex flex-wrap gap-4">
              <Link href="#list" className="btn btn-ghost">Смотреть статьи</Link>
              <Link href="#subscribe" className="btn btn-accent">Подписаться</Link>
            </div>
          </div>
        </header>

        <main className="px-4 sm:px-6 py-12 md:py-16 max-w-7xl mx-auto space-y-16">
          <section id="filters" aria-label="Фильтры статей" className="scroll-mt-32">
            <h2 className="text-3xl md:text-4xl font-bold mb-6">Подбор по параметрам</h2>
            <div className="flex flex-wrap gap-4">
              <input
                id="q"
                className="rounded-xl px-4 py-3 text-gray-900 flex-1 min-w-48"
                placeholder="Поиск по названию/тексту…"
                value={query}
                onChange={e => { setQuery(e.target.value); setPage(1); }}
              />
              <select id="cat" className="rounded-xl px-4 py-3 text-gray-900 flex-1 min-w-40" value={category} onChange={e => { setCategory(e.target.value); setPage(1); }}>
                <option value="">Категория: все</option>
                {ALL_CATS.map(c => <option key={c}>{c}</option>)}
              </select>
              <select id="tag" className="rounded-xl px-4 py-3 text-gray-900 flex-1 min-w-40" value={tag} onChange={e => { setTag(e.target.value); setPage(1); }}>
                <option value="">Тег: все</option>
                {ALL_TAGS.map(t => <option key={t}>{t}</option>)}
              </select>

              <select id="sort" className="rounded-xl px-4 py-3 text-gray-900 min-w-52" value={sort} onChange={e => { setSort(e.target.value); setPage(1); }}>
                <option value="date">Сортировать: по дате (новые ↓)</option>
                <option value="popular">по популярности</option>
                <option value="title">по названию</option>
                <option value="read">по времени чтения</option>
              </select>
              <div className="rounded-xl px-4 py-3 card flex flex-col justify-center min-w-40">
                <div className="flex justify-between items-center text-sm text-gray-200 mb-1">
                  <label>Годы:</label>
                  <span>{yearRange.start} – {yearRange.end}</span>
                </div>
                <div className="flex items-center gap-2">
                  <input
                    id="y1"
                    type="range"
                    min="2025"
                    max="2026"
                    value={yearRange.start}
                    onChange={e => { setYearRange({ ...yearRange, start: parseInt(e.target.value) }); setPage(1); }}
                    className="flex-1"
                  />
                  <input
                    id="y2"
                    type="range"
                    min="2025"
                    max="2026"
                    value={yearRange.end}
                    onChange={e => { setYearRange({ ...yearRange, end: parseInt(e.target.value) }); setPage(1); }}
                    className="flex-1"
                  />
                </div>
              </div>
            </div>
          </section>

          <section id="list" aria-label="Список статей" className="scroll-mt-32" ref={listSectionRef}>
            <div className="flex items-end justify-between gap-4 flex-wrap">
              <h2 className="text-3xl md:text-4xl font-bold">Все статьи</h2>
              <span id="count" className="text-sm text-gray-300">Найдено статей: {filteredPosts.length}</span>
            </div>
            <div id="grid" className="mt-6 grid gap-6 grid-cols-1 sm:grid-cols-2 lg:grid-cols-3">
              {paginatedPosts.length > 0 ? (
                paginatedPosts.map(post => (
                  <ArticleCard key={post.id} post={post} onOpenModal={setSelectedPost} />
                ))
              ) : (
                <p id="empty" className="text-gray-300 col-span-1 sm:col-span-2 lg:col-span-3">Ничего не найдено — измените фильтры.</p>
              )}
            </div>
            <div id="pager" className="mt-6 flex flex-wrap items-center gap-2">
              {Array.from({ length: totalPages }, (_, i) => i + 1).map(p => (
                <button
                  key={p}
                  className={`px-3 py-2 rounded-lg ${p === page ? 'btn-accent' : 'btn-ghost'}`}
                  onClick={() => {
                    setPage(p);
                    listSectionRef.current?.scrollIntoView({
                      behavior: 'smooth',
                      block: 'start',
                    });
                  }}
                >
                  {p}
                </button>
              ))}
            </div>
          </section>

          <section id="subscribe" className="simple-card scroll-mt-32">
            <h3 className="text-2xl font-bold">Подписка на обновления</h3>
            <p className="text-sm text-gray-200 mt-1">Раз в неделю — лучшие кейсы и гайды. Без спама.</p>
            <form
              className="mt-4 grid gap-3 grid-cols-1 md:grid-cols-3"
              onSubmit={handleSubmit}
            >
              <input
                className="rounded-xl px-4 py-3 text-gray-900 w-full"
                placeholder="Имя*"
                value={name}
                onChange={(e) => { setName(e.target.value); setStatus('idle'); setMessage(''); }}
                required
                disabled={isSubmitting || status === 'success'}
              />
              <input
                className="rounded-xl px-4 py-3 text-gray-900 w-full"
                placeholder="E-mail*"
                type="email"
                value={email}
                onChange={(e) => { setEmail(e.target.value); setStatus('idle'); setMessage(''); }}
                required
                disabled={isSubmitting || status === 'success'}
              />
              <button
                type="submit"
                className={`btn btn-accent rounded-xl px-4 py-3 w-full ${status === 'success' ? 'bg-green-500 hover:bg-green-600 text-white' : status === 'error' ? 'btn-ghost' : 'btn-accent'}`}
              >
                {isSubmitting ? 'Отправка...' : status === 'success' ? '✅ Успешно' : 'Подписаться'}
              </button>
              <div className="md:col-span-3">
                <CustomCheckbox
                  name="consent"
                  isChecked={isConsentChecked}
                  onChange={handleConsentChange}
                  link="/privacy"
                  textColorClass="text-gray-400 text-xs"
                  linkColorClass="text-[#FF7C22] hover:underline text-xs"
                  className="px-2 py-3"
                />
              </div>
            </form>
            <StatusMessage />
          </section>

          <section id="faq" className="scroll-mt-32">
            <h2 className="text-3xl md:text-4xl font-bold mb-6">FAQ</h2>
            <div className="space-y-3">
              <details className="simple-card"><summary className="cursor-pointer font-semibold">Как часто выходят статьи?</summary><p className="mt-2 text-sm text-gray-200">Обычно 1–2 раза в неделю. Подписка выше — чтобы не пропустить.</p></details>
              <details className="simple-card"><summary className="cursor-pointer font-semibold">Можно ли предложить тему?</summary><p className="mt-2 и text-sm text-gray-200">Да — напишите нам через форму контактов, мы свяжемся для уточнений.</p></details>
            </div>
          </section>
        </main>
      </div>
      {selectedPost && <ArticleModal post={selectedPost} onClose={() => setSelectedPost(null)} />}
    </>
  );
}